import React from "react";
import { StyleSheet, View, Dimensions } from "react-native";

import ManualTimerWidget from "./ManualTimerWidget";

export default function TimePickerManualEntry(props) {
  return (
    <View
      style={[
        styles.container,
        props.pickDuration && { minHeight: 90 },
        props.style,
      ]}
    >
      {/* START TIME */}
      <ManualTimerWidget
        {...props}
        isStartTime
        time={props.startTime}
        compareTime={props.endTime}
        label={!props.pickDuration ? "Start" : null}
        onTimeChanged={props.onTimeChanged}
      />

      {/* END TIME */}
      {props.endTime ? (
        <ManualTimerWidget
          {...props}
          time={props.endTime}
          compareTime={props.startTime}
          label="End"
          onTimeChanged={props.onTimeChanged}
        />
      ) : null}
    </View>
  );
}

const { width: WIDTH } = Dimensions.get("window");

const styles = StyleSheet.create({
  container: {
    width: WIDTH,
    maxWidth: "100%",
    borderTopWidth: 1,
    borderTopColor: "#F5F5F5",
    paddingVertical: 10,
    minHeight: 150,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
